import { Suspense, lazy } from 'react';
import { useUpdateLiveData } from '../../interpreter/hooks/useUpdateLiveData';
import WaitingScreen from '../../components/waiting_screen';
import { HudManager } from '../../app/hud/hud_manager';
import { DefaultWidgetManager } from '../../app/widget/defaultWidgetManager';
import { useVersionStore } from '../../store/sceneStore';

const MapViewWrapper = lazy(() => import('../../app/map_view/mapViewWrapper'));

const LoadingFallback = () => (
	<div className='flex h-full items-center justify-center text-2xl font-bold'>
		Loading Map...
	</div>
);

export const PassengerPage = () => {
	const version = useVersionStore();

	useUpdateLiveData();

	if (!version.accepted) {
		return <WaitingScreen waitingText={'waiting for connection...'} />;
	}

	return (
		<>
			<Suspense fallback={<LoadingFallback />}>
				<MapViewWrapper />
			</Suspense>
			<HudManager />
			<DefaultWidgetManager />
		</>
	);
};
